import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Si localStorage existe, on le prend directement, sinon la chaîne par défaut est 'fr'
  langueInfo: localStorage.getItem('langueInfo')
    ? localStorage.getItem('langueInfo')
    : 'fr'
};

const langueSlice = createSlice({
    name: 'langue',
    initialState,
    reducers: {
        setCredentialLangue: (state, action) => {
            state.langueInfo = action.payload;
            // On stocke directement la chaîne de caractères sans JSON.stringify
            localStorage.setItem('langueInfo', action.payload);
        },
    },
});

// ✅ Correction ici : attention à bien exporter depuis .actions !
export const { setCredentialLangue } = langueSlice.actions;

export default langueSlice.reducer;